import React from 'react';
import { useTranslation, Trans } from '@edreamsodigeo/frontend-core';
import { PrimeHeader } from '@/components/PrimeHeader';

export const VersionedIRUMPrimeHeader = ({
  PrimeHeaderPaddingFromLogoValue,
  days,
}) => {
  const { t } = useTranslation();
  return (
    <PrimeHeader
      title={
        <Trans i18nKey="home.header.title.1" components={{ days: `${days}` }} />
      }
      subtitle={t('home.header.subtitle.1')}
      paddingFromLogo={PrimeHeaderPaddingFromLogoValue}
    />
  );
};
